<template>
  <div class="patient-profile">
    <div v-if="isShow">
      <div :class="businessType === 5 ? 'appointment' : 'patient-title'">选择就诊人</div>
      <div class="patient-container">
        <div
          class="patient-box"
          v-for="(item, index) in patientProfileList"
          :key="index"
          :class="selectId === item.patientProfileId && 'select'"
          @click="handleClick(item)"
        >
          <div class="patient-relation">{{ patientRelationMap[item.relation] || '其他' }}</div>
          <div class="patient-name">{{ item.patientProfileName }}</div>
          <div class="patient-info">
            <span v-if="item.gender || item.gender === 0">{{ GENDER[item.gender] }}</span>
            <span v-if="item.age || item.age === 0">{{ `${item.age} 岁` }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps, defineEmits, defineExpose } from 'vue'
import { getListBusinessPatientProfile } from '@/api/workPlace/workOrder'
import { patientRelationMap } from '@/utils/globalMap'

const props = defineProps({
  ucPatientId: {
    type: String,
    value: ''
  },
  ucDoctorId: {
    type: String,
    value: ''
  },
  businessType: {
    // 业务类型：1-医生发起问诊 2-患者发起问诊 3-补充诊疗记录 4-完善用药建议 5-预约挂号（医生、健管、BD） 6-预约挂号（患者）
    type: Number,
    value: ''
  }
})

const emit = defineEmits(['handleSelect'])

const GENDER = ['女', '男']
const patientProfileList = ref([])
const selectId = ref() // 已选就诊人id
const isShow = ref(true) // 是否展示选择就诊人组件

const init = () => {
  getPatientProfile()
  selectId.value = undefined
}

// 获取就诊人列表
const getPatientProfile = async () => {
  try {
    const params = {
      ucPatientId: props.ucPatientId,
      ucDoctorId: props.ucDoctorId,
      businessType: props.businessType
    }
    const result = await getListBusinessPatientProfile(params)
    patientProfileList.value = result || []
    // 选择默认就诊人
    const defaultSelPatient = result.filter(item => item.defaultSelected === 1)
    if (defaultSelPatient.length > 0) {
      handleClick(defaultSelPatient[0])
    }
    // 只有一个就诊人的情况下，不展示选择就诊人组件
    if (result?.length === 1) {
      handleClick(result[0])
      isShow.value = false
    }
  } catch (error) {
    console.log(error)
  }
}

const handleClick = item => {
  selectId.value = item.patientProfileId
  emit('handleSelect', item)
}

onMounted(() => {
  getPatientProfile()
})

defineExpose({
  init
})
</script>

<style scoped lang="scss">
.patient-profile {
  .appointment {
    height: 12px;
    font-weight: 700;
    font-size: 16px;
    line-height: 7px;
    color: #262626;
    border-left: 3px solid #1890ff;
    padding: 3px 7px;
    margin-bottom: 16px;
  }
  .patient-title {
    padding: 14px 16px 14px 0;
    &::before {
      font-size: 14px;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
      margin-right: 4px;
    }
  }
  .patient-container {
    display: flex;
    flex-wrap: wrap;
    .patient-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      overflow: hidden;
      cursor: pointer;
      width: 170px;
      height: 58px;
      border-radius: 4px;
      background: #f5f5f5;
      margin-bottom: 23px;
      margin-right: 14px;
      position: relative;
      .patient-relation {
        position: absolute;
        top: 0;
        right: 0;
        font-weight: 400;
        font-size: 10px;
        color: #a3a3a3;
        background: #8c8c8c14;
        line-height: 14px;
        padding: 1px 3px;
        border-radius: 0 4px 0 4px;
      }
      .patient-name {
        width: 86%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 700;
        font-size: 14px;
        color: #595959;
        margin-bottom: 4px;
        text-align: center;
      }
      .patient-info {
        font-weight: 400;
        font-size: 12px;
        color: #595959;
        span {
          margin-right: 6px;
        }
      }
    }
    .select {
      background: #e2f1ff;
      border: 1.47px solid #1890ff;
      .patient-relation {
        color: #1890ffcc;
        background: #1890ff1f;
      }
    }
  }
}
</style>
